<template>
  <div>
    <div class="admin-categories">
      <header-title title="Generador de QR" />
      <Loader :dialog-loader="dialogLoader" message="Cargando..."></Loader>
      <v-container fluid>
        <v-form
          ref="form"
          v-model="isValid"
          lazy-validation
          @submit.prevent="generatePDF()"
        >
          <v-row>
            <v-col cols="12" md="3" sm="4" class="py-0 mt-3">
              <v-subheader class="pa-0" :style="{ color: formLabelTheme }"
                >Color de fondo :</v-subheader
              >
            </v-col>
            <v-col cols="12" sm="6" class="py-0 py-sm-1 d-flex">
              <v-text-field
                v-model="bgColor"
                :rules="validationRules.bgColor"
                required
                :placeholder="`E.g. ${whiteBackground}`"
                @input="changeColor()"
              ></v-text-field>
              <v-menu offset-y>
                <template v-slot:activator="{ on }">
                  <v-btn :color="bgColorPicker" dark v-on="on"> </v-btn>
                </template>
                <v-color-picker
                  :value="whiteBackground"
                  v-model="bgColorPicker"
                  hide-canvas
                  hide-inputs
                  show-swatches
                  class="mx-auto"
                  @input="onChangeColor()"
                ></v-color-picker>
              </v-menu>
            </v-col>
          </v-row>
          <!-- HTML for print QR PDF -->
          <v-row :style="{ overflow: 'hidden', height: 0 }">
            <v-col cols="12" v-for="(item, index) in pdfQrUrl" :key="item">
              <div
                v-if="generatePDFfile"
                :id="'card-qr-' + index"
                class="text-center pa-2"
                :style="{
                  backgroundSize: '250px 270px',
                  backgroundColor: pdfBgColor,
                  width: '250px',
                  height: '270px'
                }"
              >
                <div
                  class="text-left font-weight-bold"
                  :style="{
                    verticalAlign: 'text-top',
                    fontSize: '10px !important'
                  }"
                >
                  {{ pdfTextTop }}
                </div>
                <div
                  class="text-left font-weight-bold"
                  :style="{
                    fontSize: '10px !important',
                    width: '86%',
                    webkitTransform:
                      'rotate(-90deg) translateX(-100%) translateY(-40%)',
                    webkitTransformOrigin: '0% 0%'
                  }"
                >
                  {{ pdfTextLeft }}
                </div>
                <div
                  class="text-left font-weight-bold"
                  :style="{
                    fontSize: '10px !important',
                    webkitTransform:
                      'rotate(-90deg) translateX(26%) translateY(0%)',
                    webkitTransformOrigin: '100% 100%'
                  }"
                >
                  {{ pdfTextRight }}
                </div>
                <qrcode-vue
                  :value="item"
                  :background="pdfBgColor"
                  size="170"
                  level="H"
                />
                <div
                  class="text-left font-weight-bold"
                  :style="{
                    fontSize: '24px !important',
                    width: '60%',
                    float: 'left'
                  }"
                >
                  {{ pdfSelectedQR[index] }}
                </div>
                <div
                  class="text-right font-weight-bold"
                  :style="{
                    fontSize: '12px !important',
                    marginTop: '14px',
                    width: '40%',
                    float: 'right'
                  }"
                >
                  {{ pdfTextBottom }}
                </div>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="3" sm="4" class="py-0 mt-3">
              <v-subheader class="pa-0" :style="{ color: formLabelTheme }"
                >Texto lateral izquierda :
              </v-subheader>
            </v-col>
            <v-col cols="12" sm="6" class="py-0 py-sm-1">
              <v-text-field
                v-model="textLeft"
                :rules="validationRules.textLeft"
                required
                placeholder="1 // ESCANEA EL QR / SCAN QR"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="3" sm="4" class="py-0 mt-3">
              <v-subheader class="pa-0" :style="{ color: formLabelTheme }"
                >Texto superior :
              </v-subheader>
            </v-col>
            <v-col cols="12" sm="6" class="py-0 py-sm-1">
              <v-text-field
                v-model="textTop"
                :rules="validationRules.textTop"
                required
                placeholder="2 // AÑADE AL CARRITO / ADD TO CART"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="3" sm="4" class="py-0 mt-3">
              <v-subheader class="pa-0" :style="{ color: formLabelTheme }"
                >Texto lateral derecha :
              </v-subheader>
            </v-col>
            <v-col cols="12" sm="6" class="py-0 py-sm-1">
              <v-text-field
                v-model="textRight"
                :rules="validationRules.textRight"
                required
                placeholder="3 // PAGAR CON TARJETA / PAY WITH CARD"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="3" sm="4" class="py-0 mt-3">
              <v-subheader class="pa-0" :style="{ color: formLabelTheme }"
                >Texto inferior :
              </v-subheader>
            </v-col>
            <v-col cols="12" sm="6" class="py-0 py-sm-1">
              <v-text-field
                v-model="textBottom"
                :rules="validationRules.textBottom"
                required
                placeholder="LA PINADA"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="3" sm="4" class="py-0 mt-3">
              <v-subheader class="pa-0" :style="{ color: formLabelTheme }"
                >Zona :
              </v-subheader>
            </v-col>
            <v-col cols="12" sm="6" class="py-0 py-sm-1">
              <v-select
                v-model="zone_id"
                :items="zoneTablesQR"
                :rules="validationRules.zone"
                item-text="name"
                item-value="id"
                label="Selecciona una zona"
                @change="selectedQR = false"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="3" sm="4" class="py-0 mt-3">
              <v-subheader class="pa-0" :style="{ color: formLabelTheme }"
                >QRs :
              </v-subheader>
            </v-col>
            <v-col cols="12" sm="6" class="py-0 py-sm-1">
              <v-select
                v-model="selectedQR"
                :items="activesQR"
                multiple
                :rules="validationRules.qr"
                label="Selecciona QR"
                :item-text="qr => tableQRLabel(qr.table)"
                item-value="tableQR"
              >
                <template v-slot:prepend-item v-if="activesQR.length > 0">
                  <v-list-item ripple @click="selectAllQrToggle">
                    <v-list-item-action>
                      <v-icon :color="selectedQR.length > 0 ? 'primary' : ''">
                        {{ icon }}
                      </v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>
                        Todas
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider class="mt-2"></v-divider>
                </template>
              </v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col align="center">
              <div class="my-2 mr-5">
                <v-btn
                  dense
                  :style="adminNavigationBackTheme"
                  type="submit"
                  :disabled="!isValid || dialogLoader"
                >
                  <v-icon left>
                    mdi-refresh
                  </v-icon>
                  GENERAR PDF
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-form>
        <v-row>
          <v-col cols="12" md="3" sm="4" class="py-0 mt-3">
            <v-subheader class="pa-0" :style="{ color: formLabelTheme }"
              >Archivo a imprimir :
            </v-subheader>
          </v-col>
          <v-col cols="12" sm="6" class="py-0 py-sm-1">
            <v-text-field
              v-model="pdfFile"
              :rules="validationRules.pdfFileValue"
              required
              readonly
              placeholder="descargar archivo pdf"
            />
          </v-col>
          <v-col cols="2" class="py-0 mt-3">
            <v-btn
              dense
              icon
              :href="pdfFileData"
              :download="pdfFile"
              :disabled="dialogLoader || pdfFile === ''"
            >
              <v-icon>mdi-cloud-download</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>
<script>
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import QrcodeVue from "qrcode.vue";
import { qrZoneCollection } from "@/collections/qrZone";
import { qrCollection } from "@/collections/qrs";
import Loader from "@/components/common/Loader";
import HeaderTitle from "@/components/admin/common/HeaderTitle.vue";

export default {
  components: {
    HeaderTitle,
    QrcodeVue,
    Loader
  },
  data() {
    return {
      selectedQR: [],
      pdfSelectedQR: [],
      isValid: false,
      generatePDFfile: false,
      dialogLoader: false,
      pdfFile: "",
      url: `${process.env.VUE_APP_BASE_URL}/?qr=`,
      pdfQrUrl: [],
      zone_id: "",
      pdfBgColorPicker: "",
      pdfBgColor: "",
      bgColorPicker: "#FFFFFF",
      bgColor: "#FFFFFF",
      whiteBackground: "#FFFFFF",
      textTop: "2 // AÑADE AL CARRITO / ADD TO CART",
      textLeft: "1 // ESCANEA EL QR / SCAN QR",
      textRight: "3 // PAGAR CON TARJETA / PAY WITH CARD",
      textBottom: process.env.VUE_APP_PROJECT_NAME,
      pdfTextTop: "",
      pdfTextLeft: "",
      pdfTextRight: "",
      pdfTextBottom: "",
      pdfFileData: "",
      zoneTablesQR: [],
      qrCollection: [],
      validationRules: {
        textTop: [v => !!v || "Por favor, inserte superior texto"],
        textLeft: [v => !!v || "Por favor, inserte lateral izquierda texto"],
        textRight: [v => !!v || "Por favor, inserte lateral derecha texto"],
        textBottom: [v => !!v || "Por favor, inserte inferior texto"],
        bgColor: [v => !!v || "Por favor, selecciona color de fondo"],
        zone: [v => !!v || "Por favor, selecciona una zona"],
        qr: [v => v.length > 0 || "Por favor, selecciona una QR"],
        pdfFileValue: [v => !!v || "Genere un archivo PDF"]
      }
    };
  },
  firestore() {
    return {
      zoneTablesQR: qrZoneCollection,
      qrCollection: qrCollection
    };
  },
  computed: {
    selectAllqrs() {
      return this.selectedQR.length === this.activesQR.length;
    },
    activesQR() {
      let QRs = this.qrCollection.filter(item => item.zone_id === this.zone_id);
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return QRs.sort(this.dynamicsort("table", "asc"));
    },
    icon() {
      if (this.selectAllqrs) return "mdi-close-box";
      return "mdi-checkbox-blank-outline";
    }
  },
  methods: {
    selectAllQrToggle() {
      this.$nextTick(() => {
        if (this.selectAllqrs) {
          this.selectedQR = [];
        } else {
          this.selectedQR = [];
          this.activesQR.forEach(item => {
            this.selectedQR.push(this.tableQRLabel(item.table));
          });
        }
      });
    },
    onChangeColor() {
      this.bgColor = this.bgColorPicker;
    },
    changeColor() {
      this.bgColorPicker = this.bgColor;
    },
    generatePDF() {
      if (!this.$refs.form.validate()) {
        this.showErrorMessage("Revisa el formulario");
        return;
      }
      this.dialogLoader = true;
      this.generatePDFfile = false;
      let fileNameQR = "";
      this.pdfQrUrl = [];
      this.pdfSelectedQR = [];
      const textBottom = this.textBottom
        .toLowerCase()
        .split(" ")
        .join("");
      this.selectedQR.forEach((element, index) => {
        this.pdfQrUrl.push(this.url + element);
        const selectedQR = element
          .split(" ")
          .join("")
          .split("-")
          .join("_");
        this.pdfSelectedQR.push(element);
        if (index === 0) {
          fileNameQR = selectedQR;
        }
        if (index === this.selectedQR.length - 1) {
          fileNameQR = fileNameQR + "_" + selectedQR;
        }
      });
      let pdfFileName = `${textBottom + fileNameQR}.pdf`;
      this.pdfBgColorPicker = this.bgColorPicker;
      this.pdfBgColor = this.bgColor;
      this.pdfTextTop = this.textTop;
      this.pdfTextLeft = this.textLeft;
      this.pdfTextRight = this.textRight;
      this.pdfTextBottom = this.textBottom;
      this.generatePDFfile = true;
      setTimeout(() => {
        this.createPDFFile(pdfFileName);
      }, 100);
    },
    createPDFFile(filename) {
      const pdf = new jsPDF("p", "pt", [200, 200]);

      // create multiple qr in pdf
      this.pdfQrUrl.forEach((item, index) => {
        const element = document.getElementById("card-qr-" + index);
        const width = pdf.internal.pageSize.getWidth();
        const height = pdf.internal.pageSize.getHeight();
        const self = this;
        html2canvas(element, { allowTaint: true, useCORS: true }).then(function(
          canvas
        ) {
          const img = canvas.toDataURL("image/jpeg", 0.8);
          pdf.addImage(img, "JPEG", 0, 0, width, height);
          index !== self.pdfQrUrl.length - 1 ? pdf.addPage() : "";
          if (index === self.pdfQrUrl.length - 1) {
            self.pdfFileData = pdf.output("datauristring");
            self.pdfFile = filename;
            self.dialogLoader = false;
            self.showSuccessMessage("PDF generado con éxito");
          }
        });
      });
    }
  }
};
</script>
